/**
 * @file Re-exports the InvestmentAccreditationUpdateModal component.
 */
import InvestmentAccreditationUpdateModal from "./InvestmentAccreditationUpdateModal";

export default InvestmentAccreditationUpdateModal;
